import type { CustomerStore } from '../model/customer-store/interfaces'
import type { CustomerResponse } from '@brighterly/lib-core-types/customer/interfaces'

import { apiRoutes as routes } from '@shared/api'

import { _setCustomer } from '../model/customer-store/set-customer'

export const _fetchCustomer = async (state: CustomerStore, silent: boolean): Promise<CustomerStore['customer']> => {
  if (state._inFlight) {
    return state._inFlight
  }

  const { $axios } = useNuxtApp()

  if (!silent) {
    state.status = state.customer
      ? 'ready'
      : 'loading'
  }

  state._inFlight = (async () => {
    try {
      const url = routes['me']
      const { data } = await $axios.get<CustomerResponse>(url)
      const customer = data?.data || null

      _setCustomer(state, customer)

      return state.customer

    } catch (err) {
      console.error(err)

      state.status = state.customer
        ? 'ready'
        : 'error'

      return state.customer
    } finally {
      state._inFlight = null
    }
  })()

  return state._inFlight
}
